/*
 * @Description: 心智占有率-物流行业表现与对比
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 16:03:00
 * @LastEditTime: 2019-03-28 17:40:57
 */
import baseChart from './customBaseChart';
import { isArray } from 'util';

const itemStyle = {
  normal: {
    opacity: 0.7,
    borderWidth: 1,
    borderColor: '#000'
  }
};

const createItemStyle = (color) => ({
  itemStyle: {
    normal: {
      color: color
    }
  }
})


const handleData = (list) => {
  return list.map(item => {
    return {
      name: item.name,
      value: Math.abs(item.value),
      ...createItemStyle(item.value > 0 ? '#ffd70d' : '#44548f')
    }
  })
};


const group = (list) => {
  let name, value;
  if (isArray(list) && list.length > 0) {
    name = list[0].name;
    value = (list[0].value / list.map(v => v.value).reduce((prev, current) => prev + current) * 100).toFixed(2) + '%';
  } else {
    name = 0;
    value = 0;
  }

  const title = {
    type: 'text',
    left: 'center',
    top: '50%',
    z: 100,
    style: {
      text: name,
      fill: '#eead81',
      font: '22px "STHeiti", sans-serif'
    }
  };

  const num = {
    type: 'text',
    left: 'center',
    top: '80%',
    z: 100,
    style: {
      text: value,
      fill: '#eead81',
      font: '22px "STHeiti", sans-serif'
    }
  };
  
  return {
    type: 'group',
    left: 'center',
    top: 'center',
    width: 135,
    height: 135,
    z: 100,
    children: [ title, num ]
  }
};

export default (opt = {}) => {
  const list = handleData(opt.list || []);

  return Object.assign(baseChart(opt), {
    
    graphic: [
      {
        type: 'rect',
        z: 80,
        left: '20',
        top: '60',
        shape: {
          width: 230,
          height: 44
        },
        style: {
          fill: '#ffd70d',
          stroke: '#999'
        }
      }, {
        type: 'text',
        left: '20',
        top: 65,
        z: 100,
        style: {
          text: ' ● 阴影区颜色为黄色，表明好感度为正值；',
          stroke: '#ffd70d',
          font: '12px "STHeiti", sans-serif'
        }
      }, {
        type: 'text',
        left: '30',
        top: 85,
        z: 100,
        style: {
          text: ' 若为蓝色，表明好感度为负值。',
          stroke: '#44548f',
          font: '12px "STHeiti", sans-serif'
        }
      },
      group(list)
    ],
    legend: {
      type: 'scroll',
      orient: 'vertical',
      padding: 20,
      top: '20',
      right: '10',
      bottom: '20',
      y: 'bottom',
      data: list.map(item => item.name),
      inactiveColor: '#ccc'
    },
    series: [
      {
        name: '心智占有率',
        type: 'pie',
        radius: [
          '30%', '80%'
        ],
        center: [
          '50%', '50%'
        ],
        startAngle: 90,
        roseType: 'area',
        avoidLabelOverlap: true,
        label: {
          normal: {
            formatter: `{b|{b}} {per|{d}%}`,
            backgroundColor: '#f2f2f2',
            borderColor: '#aaa',
            borderRadius: 4,
            padding: [
              0, 0
            ],
            rich: {
              a: {
                color: '#999',
                lineHeight: 22,
                align: 'center'
              },
              hr: {
                borderColor: '#aaa',
                width: '100%',
                borderWidth: 0.5,
                height: 0
              },
              b: {
                fontSize: 14,
                lineHeight: 25,
                color: '#333',
                align: 'center'
              },
              per: {
                color: '#eee',
                backgroundColor: '#334455',
                align: 'center',
                padding: [
                  2, 4
                ],
                borderRadius: 2,
                fontSize: 14,
              }
            }
          },
          emphasis: {
            show: true
          }
        },
        lableLine: {
          normal: {
            show: true
          },
          emphasis: {
            show: true
          }
        },
        data: list.sort((a, b) => b.value - a.value),
        itemStyle: itemStyle
      }
    ]
  });
};


// WEBPACK FOOTER //
// src/chart/_shareOfMind.js